/**
 * Rounds a number to exactly two decimal places.
 * @param {number|string} value - The value to round.
 * @returns {number} The rounded value.
 */
export const roundToTwoDecimals = (value) => {
  if (value === null || value === undefined || value === '') {
    return 0;
  }
  const num = parseFloat(value);
  if (isNaN(num)) {
    return 0;
  }
  return Math.round((num + Number.EPSILON) * 100) / 100;
};
